import React from "react";
import { Link, graphql } from "gatsby";
import Layout from "components/Layout";
import Seo from "components/Seo";
import SubpageHeader from "components/SubpageHeader";
import "../styles/pages/page-policy.scss";
import useTranslation from "locales";

const Policy = ({ pageContext, data }) => {
  const seo = pageContext.seo;
  const policies = data.policies.nodes;
  const lang = pageContext.language?.slug;
  const policiesFiltered = policies.filter((el) => {
    return el.language.slug === lang;
  });
  const { t } = useTranslation(lang);
  return (
    <Layout className="bg-blue" lang={lang}>
      <Seo
        title={seo.title ? seo.title : pageContext.title}
        description={seo.metaDesc}
      />
      <div style={{ height: "40px" }} />
      <SubpageHeader lang={lang} title="Regulaminy" back={t("/")} />
      <section className="section-policy">
        <div className="container">
          <div className="row section-policy__content">
            <div className="col-lg-3 section-policy__menu">
              <ul className="section-policy__menu-container">
                {policiesFiltered.map((item, index) => {
                  return (
                    <li className="section-policy__menu-item" key={index}>
                      <Link
                        to={item.uri}
                        className="section-policy__menu-link"
                        activeClassName="section-policy__menu-link--active"
                        partiallyActive
                      >
                        {item.title}
                      </Link>
                    </li>
                  );
                })}
                {/* <li className="section-policy__menu-item">
                           <Link
                              to="/regulaminy"
                              className="section-policy__menu-link"
                              activeClassName="section-policy__menu-link--active"
                              partiallyActive
                           >
                              POLITYKA
                              <br /> PRYWATNOŚCI
                           </Link>
                        </li>
                        <li className="section-policy__menu-item">
                           <Link
                              to="#"
                              className="section-policy__menu-link"
                              activeClassName="section-policy__menu-link--active"
                              partiallyActive
                           >
                              Regulamin SPRZEDAŻY
                              <br /> BILETÓW ONLINE
                           </Link>
                        </li>
                        <li className="section-policy__menu-item">
                           <Link
                              to="#"
                              className="section-policy__menu-link"
                              activeClassName="section-policy__menu-link--active"
                              partiallyActive
                           >
                              Regulamin porządkowy wystawy <br />
                              „PIOTRUŚ PAN - OGRÓD ŚWIATEŁ”
                           </Link>
                        </li>
                        <li className="section-policy__menu-item">
                           <Link
                              to="#"
                              className="section-policy__menu-link"
                              activeClassName="section-policy__menu-link--active"
                           >
                              Regulamin porządkowy wystawy
                              <br />
                              „LAMPA ALADYNA - OGRÓD ŚWIATEŁ”
                           </Link>
                        </li>
                        <li className="section-policy__menu-item">
                           <Link
                              to="#"
                              className="section-policy__menu-link"
                              activeClassName="section-policy__menu-link--active"
                              partiallyActive
                           >
                              Regulamin porządkowy wystawy
                              <br /> „KRÓLEWNA ŚNIEŻKA - OGRÓD ŚWIATEŁ”
                           </Link>
                        </li>
                        <li className="section-policy__menu-item">
                           <Link
                              to="#"
                              className="section-policy__menu-link"
                              activeClassName="section-policy__menu-link--active"
                              partiallyActive
                           >
                              Regulamin usługi <br /> NEWSLETTER OGRÓD ŚWIATEŁ
                           </Link>
                        </li> */}
              </ul>
            </div>
            <div
              className="col-lg-8 offset-lg-1 section-policy__paragraph"
              dangerouslySetInnerHTML={{ __html: pageContext.data.content }}
            ></div>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query {
    policies: allWpPage(
      filter: { template: { templateName: { eq: "Regulamin" } } }
      sort: { fields: menuOrder, order: ASC }
    ) {
      nodes {
        title
        uri
        menuOrder
        language {
          slug
        }
      }
    }
  }
`;

export default Policy;
